import { Input } from "@/components/ui/input";
import { useTran } from "@/hooks";

const SearchInput = ({ value, onChange, placeholder, label }) => {
  const { t } = useTran();
  return (
    <div className="flex-1 min-w-[200px] space-y-1.5">
      <label className="text-sm font-medium text-foreground">
        {label || t("Search")}
      </label>
      <Input
        placeholder={placeholder || t("Search...")}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default SearchInput;
